export default __webpack_public_path__ + "static/media/SCN-GST-Template.cae5e668.xlsx";